
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/serieses/[slug]",
      function () {
        return require("private-next-pages/serieses/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/serieses/[slug]"])
      });
    }
  